import cronstrue from "cronstrue/i18n";

type CronExp = string | null | undefined;

/**
 * Convierte el campo de día de semana de un cron (1-7) al formato esperado por cronstrue (0-6).
 */
function convertCronExpression(cronExpression: CronExp): CronExp {
    if (!cronExpression || typeof cronExpression !== "string") {
        return cronExpression;
    }

    const parts = cronExpression.split(" ");
    if (parts.length >= 5) {
        const dayOfWeek = parts[4];
        if (dayOfWeek !== "*" && dayOfWeek !== "?") {
            const convertedDay = dayOfWeek
                .split(",")
                .map((day) => {
                    if (day.includes("-")) {
                        const [start, end] = day.split("-");
                        const convertedStart = convertDayNumber(start);
                        const convertedEnd = convertDayNumber(end);
                        return `${convertedStart}-${convertedEnd}`;
                    } else if (!isNaN(Number(day))) {
                        return convertDayNumber(day);
                    }
                    return day;
                })
                .join(",");

            parts[4] = convertedDay;
        }
    }

    return parts.join(" ");
}

/**
 * Convierte un número de día (1-7) al rango 0-6.
 */
function convertDayNumber(dayStr: string): string {
    const day = parseInt(dayStr, 10);
    if (day === 1) return "0"; // Domingo: 1 -> 0
    if (day >= 2 && day <= 7) return String(day - 1); // Lun-Sab: 2-7 -> 1-6
    return dayStr;
}

/**
 * Wrapper de cronstrue que ajusta el formato de días antes de generar la descripción.
 */
const cronstrueWrapper = {
    ...cronstrue,
    toString(cronExpression: string,): string {
        const convertedExpression = convertCronExpression(cronExpression);
        return cronstrue.toString(convertedExpression as string,);
    },
} as typeof cronstrue;

export default cronstrueWrapper;
